import { useState } from 'react';
import PropTypes from 'prop-types';
import useMediaQuery from '@mui/material/useMediaQuery';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import useConfig from 'src/hooks/useConfig';
import { HORIZONTAL_MAX_ITEM, MenuOrientation } from 'src/config';

import useInterface from 'src/hooks/useInterface';
import NavItem from 'src/components/ui/NavItem';
import NavGroup from 'src/components/ui/NavGroup';
import { CustomLinks } from './styled/CustomLinks';

const DashboardNavigation = ({ drawerOpen: drawerOpenProp, menuItems = [] }) => {
	const { isDrawerOpen } = useInterface();
	const drawerOpen =
		drawerOpenProp === undefined ? isDrawerOpen : drawerOpenProp;
	const { menuOrientation } = useConfig();
	const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

	const [selectedID, setSelectedID] = useState('');
	const [selectedItems, setSelectedItems] = useState('');
	const [selectedLevel, setSelectedLevel] = useState(0);

	const isHorizontal =
		menuOrientation === MenuOrientation.HORIZONTAL && !downLG;

	const lastItem = isHorizontal ? HORIZONTAL_MAX_ITEM : null;
	let lastItemIndex = menuItems.length - 1;
	let remItems = [];
	let lastItemId;

	//  first it checks menu item is more than giving HORIZONTAL_MAX_ITEM after that get lastItemid by giving horizontal max
	// item and it sets horizontal menu by giving horizontal max item lastly slice menuItem from array and set into remItems

	if (lastItem && lastItem < menuItems.length) {
		lastItemId = menuItems[lastItem - 1].id;
		lastItemIndex = lastItem - 1;
		remItems = menuItems.slice(lastItem - 1, menuItems.length).map((item) => ({
			title: item.title,
			elements: item.children,
			icon: item.icon,
			...(item.url && {
				url: item.url,
			}),
		}));
	}

	const navGroups = menuItems.slice(0, lastItemIndex + 1).map((item, index) => {
		switch (item.type) {
			case 'group':
				if (item.url && item.id !== lastItemId) {
					return (
						<List key={item.id} {...(isHorizontal && { sx: { mt: 0.5 } })}>
							{!isHorizontal && index !== 0 && <Divider sx={{ my: 0.5 }} />}
							<NavItem
								item={item}
								level={1}
								isParents
								setSelectedID={setSelectedID}
							/>
						</List>
					);
				}

				return (
					<NavGroup
						key={item.id}
						setSelectedID={setSelectedID}
						setSelectedItems={setSelectedItems}
						setSelectedLevel={setSelectedLevel}
						selectedLevel={selectedLevel}
						selectedID={selectedID}
						selectedItems={selectedItems}
						lastItem={lastItem}
						remItems={remItems}
						lastItemId={lastItemId}
						item={item}
					/>
				);
			default:
				return (
					<Typography key={item.id} variant="h6" color="error" align="center">
						Fix - Navigation Group
					</Typography>
				);
		}
	});

	return (
		<CustomLinks
			sx={{
				pt: drawerOpen ? (isHorizontal ? 0 : 2) : 0,
				...(!isHorizontal && { '& > ul:first-of-type': { mt: 0 } }),
				display: isHorizontal ? { xs: 'block', lg: 'flex' } : 'block',
			}}
		>
			{navGroups}
		</CustomLinks>
	);
};

DashboardNavigation.propTypes = {
	menuLoading: PropTypes.bool,
	drawerOpen: PropTypes.bool,
	menuItems: PropTypes.any, // TODO: interface needed
};

export default DashboardNavigation;
